import { useMutation, useQueryClient } from "react-query";
import { crearCapacidad, updateCapacidad, deleteCapacidad} from '../../services/Capacidades';
import { toast } from 'react-hot-toast';

const queryKey = "capacidades";

export const useCapacidadesMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addCapacidad = useMutation((body) => crearCapacidad(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateCapacidadC = useMutation(
    (body) => updateCapacidad( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeCapacidad = useMutation((id) => deleteCapacidad( id), {
    onSuccess,
    onError,
  });

  return { addCapacidad, updateCapacidadC, removeCapacidad };
};
export default useCapacidadesMutations;